import { type FC } from 'react';
import { IconEditFilled, VStack } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';
import { OrderProductCharacteristics, type OrderProductProps } from '@/shared/components/OrderProduct';
import styles from './OrderVariantsEditButton.module.css';

interface OrderVariantsEditButtonProps extends Pick<OrderProductProps, 'characteristics'>, TestProps {
    onClick: VoidFunction;
}

export const OrderVariantsEditButton: FC<OrderVariantsEditButtonProps> = ({
    'data-testid': dataTestId = 'OrderVariantsEditButton',
    characteristics,
    onClick,
}) => (
    <VStack alignItems="flex-start">
        <button data-testid={dataTestId} className={styles.button} onClick={onClick}>
            <VStack className={styles.iconWrapper} justifyContent="center">
                <IconEditFilled className={styles.icon} size="16" />
            </VStack>

            <OrderProductCharacteristics className={styles.characteristics} characteristics={characteristics} />
        </button>
    </VStack>
);
